import { type CancellablePromise, get, post } from "@/api";
import type { CompanyDanskeBankDictionarySuggestion, CompanyNordeaDictionarySuggestion } from "@/validation";

export function getFormData(dictionaryId: string): CancellablePromise<{ dictionaryName: string }> {
  return get(`/v1/company-dictionary/${dictionaryId}/suggestion-form-data`);
}

export function sendSuggestion<T extends CompanyNordeaDictionarySuggestion | CompanyDanskeBankDictionarySuggestion>(
  dictionaryId: string,
  suggestion: T
): CancellablePromise<void> {
  return post(`/v1/company-dictionary/${dictionaryId}/suggestion`, suggestion);
}
